export enum USER_ROLE{
	Admin='68582ab0-0bf4-4b4d-98c9-71b45bd9b147',
	Student='65ab84b2-c6bc-4725-9ae6-11c208c664ba',
	Educator='58d6e6a6-d875-42f8-a0b9-56ac124aa9cb',
	Partner='71733c24-0255-49db-9a3b-3c77df03fbb3',
	CharityAdmin='f68b13b8-42b6-4eb5-a971-159c81965d91'
}